import { FormEvent, useMemo } from 'react';
import { Filter, ProductClass } from '../../../../types/catalog';
import FilterAccordion from './filter-accordion';
import ClassAccordion from './class-accordion';
import { FilterValues } from '../../../catalog';

interface FilterSidebarProps {
    showTitle: boolean;
    showSearch: boolean;
    query: string;
    setQuery: (q: string) => void;
    filters: Filter[];
    filterValues: FilterValues;
    classes: ProductClass[];
    classId: string | null;
    setClassId: (id: string | null) => void;
    toggleFilterValue: (filterIdx: number, valueIdx: number) => void;
    resetFilters: () => void;
    isOpen: boolean;
    toggleOpen: () => void;
}

function FilterSidebar({
    showTitle,
    showSearch,
    query,
    setQuery,
    filters,
    filterValues,
    classes,
    classId,
    setClassId,
    toggleFilterValue,
    resetFilters,
    isOpen,
    toggleOpen,
}: FilterSidebarProps) {
    const onSearch = (e: FormEvent) => {
        e.preventDefault();
        // @ts-ignore
        const input = (e.target as HTMLFormElement).elements['category-search'];
        const val = input.value;
        setQuery(val);
    };
    const visibleFilters = useMemo(
        () => filters.map((f, idx) => [f, idx] as [Filter, number]).filter(([f]) => f.values.length > 1),
        [filters]
    );
    return (
        <div className={'filter' + (isOpen ? ' filter--fixed' : '')} onClick={toggleOpen}>
            <div className="filter__inner" onClick={(e) => e.stopPropagation()}>
                {isOpen && <div className="filter-close" onClick={toggleOpen} />}
                {showTitle && <div className="filter__title">Фильтр по параметрам</div>}
                {classes.length > 1 && (
                    <div className="filter__params">
                        <ClassAccordion classes={classes} classId={classId} setClassId={setClassId} />
                    </div>
                )}
                {showSearch && (
                    <div className="catalog-sidebar__search filter-sidebar__search">
                        <form className="ui-search" onSubmit={onSearch}>
                            <div className="ui-input">
                                <input
                                    key={query}
                                    className="ui-input__control"
                                    name="category-search"
                                    placeholder="Поиск по текущему разделу"
                                    defaultValue={query}
                                />
                            </div>
                            <button type="submit" className="ui-search__button">
                                <i className="icon-search" />
                            </button>
                        </form>
                    </div>
                )}
                <div className="filter__params">
                    {visibleFilters.map(([f, idx], conIdx) => (
                        <FilterAccordion
                            key={f.id}
                            {...f}
                            selected={filterValues[f.id] || []}
                            openDefault={conIdx < 4 || filterValues[f.id]?.length > 0}
                            toggleValue={(f) => toggleFilterValue(idx, f)}
                        />
                    ))}
                    <div className="ui-button ui-button--gray" onClick={resetFilters}>
                        Сбросить
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterSidebar;
